// Core
import { connect } from 'react-redux';
// Actions
import { setSelection, setInner } from '../../../../ducks/withShop/Methods';

import Component from './Component';

const mapStateToProps = state => ({
    selection: state.withShop.q7.selection,
    inner: state.withShop.q7.inner,
});

const mapDispatchToProps = {
    setSelection,
    setInner,
};

const Q7 = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Q7;